import { connect } from 'react-redux'
import {toggleFullscreen} from '../../../../actions/exam';
import FullScreenIcon from "./FullScreenIcon";

const mapStateToProps = (state, ownProps) => {
  return {

  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onToggleFullscreen: () => dispatch(toggleFullscreen())
  };
};

const FullScreenIconContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FullScreenIcon);

export default FullScreenIconContainer
